import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "../locales/en/translation.json";
import translationTH from "../locales/th/translation.json";

const resources = {
  en: { translation: translationEN },
  th: { translation: translationTH },
};

i18n
  .use(LanguageDetector) // <<< ใช้ Language Detector ก่อน Init
  .use(initReactI18next)
  .init({
    resources,
    //lng: "th", // ค่าเริ่มต้นเป็นภาษาไทย
    //fallbackLng: "en",
    fallbackLng: "th",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    debug: false,
  })
  .then(() => {
    //  Logic Check หลังจาก init เสร็จ
    const savedLang = localStorage.getItem("i18nextLng");
    if (!savedLang) {
      i18n.changeLanguage("th"); // ถ้าไม่มี i18nextLng -> ตั้งภาษาไทยทันที
      console.log("No language found, defaulting to Thai (th)");
    } else {
      console.log(`Detected language: ${savedLang}`);
    }
  });

// เพิ่มการรีโหลดทรัพยากรเมื่อมีการอัปเดต JSON
i18n
  .reloadResources()
  .then(() => {
    console.log("Resources reloaded successfully");
  })
  .catch((err) => {
    console.error("Error reloading resources", err);
  });

export default i18n;
